// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fidsy theme for the view-only agent designer (vue-flow).
   All rules are namespaced under .agent-designer so they never leak into the
   rest of the app. Node card visuals live here (rather than scoped in the node
   SFCs) so they stay consistent and unaffected by vue-flow's node wrappers. */

.agent-designer {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fbfaff;
  /* subtle Fidsy dot grid */
  background-image: radial-gradient(circle, #e4dff4 1px, transparent 1px);
  background-size: 22px 22px;
}

.agent-designer .vue-flow__pane {
  cursor: grab;
}
.agent-designer .vue-flow__pane.dragging {
  cursor: grabbing;
}

/* view-only: handles are visible coloured "ports" but inert (no connecting) */
.agent-designer .vue-flow__handle {
  width: 7px;
  height: 18px;
  min-width: 0;
  min-height: 0;
  border: none;
  border-radius: 4px;
  pointer-events: none;
}
/* configuration / left side ports — Fidsy blue */
.agent-designer .vue-flow__node-config .vue-flow__handle,
.agent-designer .vue-flow__node-agent .vue-flow__handle-left {
  background: #41a0ff;
}
/* tools / right side ports — Fidsy purple */
.agent-designer .vue-flow__node-tool .vue-flow__handle,
.agent-designer .vue-flow__node-agent .vue-flow__handle-right {
  background: #5b47c2;
}

/* ---- edges (Fidsy purple, dashed, animated) ---- */
.agent-designer .vue-flow__edge.agent-edge .vue-flow__edge-path {
  stroke: #5b47c2;
  stroke-width: 2;
  stroke-linecap: round;
}
.agent-designer .vue-flow__edge.agent-edge.animated .vue-flow__edge-path {
  stroke-dasharray: 6;
  animation: ad-dashdraw 0.7s linear infinite;
}
@keyframes ad-dashdraw {
  from {
    stroke-dashoffset: 12;
  }
  to {
    stroke-dashoffset: 0;
  }
}

/* ---- node cards ---- */
.agent-designer .ad-node {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e7e3f5;
  border-radius: 12px;
  box-shadow: 0px 0px 4px rgba(71, 41, 111, 0.16);
  font-family: 'Inter', sans-serif;
  cursor: default;
}

.agent-designer .ad-node--side {
  width: 210px;
  min-height: 64px;
  padding: 10px 12px;
}

.agent-designer .ad-node__visual {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f3f0fd;
  color: #5b47c2;
  overflow: hidden;
}
.agent-designer .ad-node__visual-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.agent-designer .ad-node__body {
  min-width: 0;
}
.agent-designer .ad-node__name {
  font-size: 13px;
  font-weight: 600;
  color: #1c1955;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.agent-designer .ad-node__subtitle {
  font-size: 11px;
  color: #9b97b5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.agent-designer .ad-node__logo {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  object-fit: contain;
}

/* ---- agent (center) ---- */
.agent-designer .ad-node--agent {
  width: 236px;
  min-height: 64px;
  padding: 12px 14px;
  border: 1.5px solid #c9bff1;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f4ff 100%);
  box-shadow: 0px 2px 4px rgba(35, 17, 131, 0.16);
}
.agent-designer .ad-agent__icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #5b47c2;
  color: #ffffff;
}
.agent-designer .ad-agent__body {
  min-width: 0;
  flex-grow: 1;
}
.agent-designer .ad-agent__name {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #1c1955;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.agent-designer .ad-agent__model {
  font-size: 11px;
  color: #8884a6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

/* ---- column container wrappers ---- */
/* The visible box lives on the node wrapper itself (vue-flow reliably sizes it
   to the node's width/height). pointer-events:none so this large decorative
   region never blocks panning; !important beats vue-flow's inline pointer-events.
   The fill stays translucent so the animated connectors show through it; the
   border carries the grouping, so it needs real contrast. */
.agent-designer .vue-flow__node-container {
  pointer-events: none !important;
  box-sizing: border-box;
  border: 1.5px solid #9b8bd4;
  border-radius: 18px;
  background: rgba(91, 71, 194, 0.05);
  box-shadow: 0 2px 16px rgba(35, 17, 131, 0.07);
}
/* the title is the container node's root element (direct child of the wrapper),
   pinned to the top and centred across the full container width */
.agent-designer .ad-group__title {
  position: absolute;
  top: 11px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6d6298;
  pointer-events: none;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
